// config/appPopups.tsx
import { PopupItem, PopupIdentifier } from "./app_popup_manager_context.types";
import { KYCStatusUpdate } from "@/components/pages/user/dashboard/profile/profile_snippets/KYCPageDev/_components/KYCStatusUpdate";
import { KYCDevPopup } from "@/components/pages/user/dashboard/profile/profile_snippets/KYCPageDev/_components/KYCDevPopup";

export const APP_POPUP_POOL: PopupItem[] = [
  {
    identifier: PopupIdentifier.KYC_STATUS_UPDATE,
    component: <KYCStatusUpdate />,
    defaultDuration: null, // Stays open until manually closed
    maxWidth: "max-w-xl",
  },
  {
    identifier: PopupIdentifier.KYC_DEV,
    component: <KYCDevPopup />,
    defaultDuration: null, // Stays open until manually closed
    maxWidth: "max-w-4xl",
  },
  {
    identifier: PopupIdentifier.KYC_PENDING_REVIEW,
    component: <div>Please complete your KYC document verification.</div>,
    defaultDuration: null, // Stays open until manually closed
    maxWidth: "max-w-xl",
  },
  {
    identifier: PopupIdentifier.FEATURE_ANNOUNCEMENT,
    component: <div>Check out our new property management tools!</div>,
    defaultDuration: 5000,
  },
];
